import { render, staticRenderFns } from "./TreatmentEdit.vue?vue&type=template&id=16c87464"
import script from "./TreatmentEdit.vue?vue&type=script&lang=js"
export * from "./TreatmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports